import {endPointMenu } from "modules/main/services/endpoints";
import AppMenu from "./appMenu";
import { useFetch } from "modules/main/hooks/useFetch";
import { AppMenuOptions } from "modules/main/types/menus";
import { CartSheet } from "../../cart/components/cartSheet";
import { SearchBar } from "./searchBar";
import { Link } from "react-router-dom";
import { ChevronDown, MapPin } from "lucide-react";

import { AvatarOptions } from "modules/users/avatar-options";
import { useMediaQuery } from "@/hooks/use-media-query";
import { isDesktopSize } from "utils/is-desktop";

import { MainLogo } from "../assets/main_logo";

import { cn } from "@/lib/utils";
import { StorePreferences } from "modules/users/components/storePreferences";
import { useContext, useEffect, useState } from "react";
import { AppDataContext } from "../context/appData";
import { useAuth } from "modules/authentication/hooks/use-auth";

import { LoginDialog } from "modules/authentication/components/loginDialog";
import { LocationRequiredDialog } from "./location-required-dialog";
import { LOCATION_UPDATED_EVENT, getLocationSelectorLabel, hasSelectedLocation, readUserDataFromLocalStorage } from "modules/main/services/location-storage";
// import { useDriver } from "../hooks/useDriver";



interface HeaderProps {
    noSearch?:boolean
    noMenu?:boolean
    noCart?:boolean
    openCartSheet?: boolean;
    setOpenCartSheet?: (open: boolean) => void;
}


const Header:React.FC<HeaderProps> =  ({noSearch,noMenu,noCart, openCartSheet, setOpenCartSheet}) => { 
    const {data} = useFetch<AppMenuOptions[]>(endPointMenu);
    // const [settingsOpen, setSettingsOpen] = useState(false);
    const menu = data?data:[];
    const isDesktop = useMediaQuery(isDesktopSize);
    const {storeList} = useContext(AppDataContext);
    const [showStoresAvailable,setShowStoresAvailable] = useState(false);
    const [isLocationDialogOpen, setIsLocationDialogOpen] = useState(false);
    const [locationLabel, setLocationLabel] = useState(() => getLocationSelectorLabel(readUserDataFromLocalStorage()));
    const {isLogged, isPremiumUser} = useAuth();    
    // const driverObj = useDriver();

    useEffect(() => {
        const syncLocationLabel = () => {
            setLocationLabel(getLocationSelectorLabel(readUserDataFromLocalStorage()));
        };

        syncLocationLabel();
        window.addEventListener(LOCATION_UPDATED_EVENT, syncLocationLabel as EventListener);

        return () => {
            window.removeEventListener(LOCATION_UPDATED_EVENT, syncLocationLabel as EventListener);
        };
    }, []);

    // useEffect(() => {
    //     const userData = readUserDataFromLocalStorage();

        // if (hasSelectedLocation(userData)) {
            // driverObj.destroy();
            // return;
        // }

    //     driverObj.highlight({
    //         element: "#location-selector",
    //         popover: {
    //             title: "Selecciona tu ubicación",
    //             description: "Selecciona tu comuna y sector para ver los productos disponibles en tu área.",
    //         }
    //     });
    // }, [driverObj, locationLabel]);

    const handleLocationTriggerClick = () => {
        // driverObj.destroy();
        setIsLocationDialogOpen(true);
    };

    const handleLocationSelected = () => {
        setIsLocationDialogOpen(false);
        setShowStoresAvailable(true);
    };

    return (
    <header className={cn("flex flex-col border-b bg-background lg:bg-background z-50",
                {
                    "sticky top-[-35px]":!noCart,
                    "sticky top-[0px]":!isLogged,
                    "pb-3":!isDesktop

                })}>
        {/* {(!noCart)&&( */}
        <div className='flex justify-between w-full top-0 py-2 px-4 md:px-8 header_fix text-slate-200'>
            <button className="flex items-center" id="location-selector" onClick={handleLocationTriggerClick} type="button">
                <MapPin size={16}/><span className='ml-2 text-xs'>{locationLabel}</span>
                <ChevronDown size={16} className="ml-2"/>
            </button>
            {
            showStoresAvailable&&(
                <StorePreferences storeList={storeList} openState={showStoresAvailable} openControl={setShowStoresAvailable}/>
            )
            }
            <LocationRequiredDialog
                open={isLocationDialogOpen}
                onOpenChange={setIsLocationDialogOpen}
                onLocationSelected={handleLocationSelected}
                title="Selecciona tu ubicacion"
                description="Elige tu comuna y sector para ver precios, stock y despacho correctos en tu zona."
            />
            
            <div className="flex items-center">
                {/* <span className='text-xs'>¿Cómo funciona?</span>             */}
            </div>            
        </div>   
        <div className={cn("flex items-center mx-4 mb-1 md:my-3 lg:px-6 gap-4",{
            "justify-between":isDesktop,
            "":!isDesktop
        })}>
            {
            (!isDesktop && !noMenu)&&(
            <div className="">
                <AppMenu menu={menu} mobile={true}/>
            </div>
            
            )
            }
            <div className={cn({"ml-0":!isDesktop})}>
                <Link to="/"><div className="flex flex-row items-center lg:ml-8 text-foreground lg:text-foreground gap-2">
                    {/* <Bot size={48}/> */}
                    <MainLogo color={(isDesktop)?"#F97316":"#F97316"} classname="w-10"/>                    
                    <div className="flex items-center gap-1">
                        <span className={`font-bold mt-3 russo-one-regular ${(isDesktop)?"logo-text":"logo-text"}`} >Carriapp</span>
                        {isPremiumUser && (
                        <span className="inline-flex h-4 items-center rounded-full border border-border/50 bg-background px-1.5 text-[10px] font-semibold leading-none">
                            <span className="font-semibold bg-[linear-gradient(90deg,#F9802D_0%,#F9802D_42%,#5CA273_100%)] bg-[length:220%_220%] bg-clip-text text-transparent animate-[ai-border-flow_8s_cubic-bezier(0.4,0,0.2,1)_infinite]">
                                +Plus
                            </span>
                        </span>
                        )}
                    </div>
                    </div>
                </Link>            
            </div>            
            {(!noSearch && isDesktop)&&
            (                
                <SearchBar className="mx-auto w-[90dvw] lg:w-[60dvw]"/>
            )
            }                            
            <div className="flex justify-end ml-auto gap-5">
                {isLogged?
                (<>
                <div className="flex flex-col items-center gap-1">
                    {(!noCart)&&<CartSheet open={openCartSheet} setOpen={setOpenCartSheet} />}
                    <span className="text-xs"></span>
                </div>
                <div className="flex flex-col items-center gap-1">
                    <AvatarOptions isMobile={false}/>
                </div>                
                </>                        
                )
                :(
                <div className="flex flex-row items-center justify-between lg:justify-end gap-4 lg:gap-8 w-full">
                
                {(!noCart)&&<CartSheet open={openCartSheet} setOpen={setOpenCartSheet} />}
                <LoginDialog mobile={!isDesktop}/>            
                </div>
                )
                }   
            </div>         
        </div>
        {
        (!isDesktop && !noSearch)&&(
        <SearchBar className="mx-4 justify-center"/>
        )
        }
        {(!noMenu)&&(            
            (isDesktop)?
            (
        <div className={cn(
            "flex my-2 items-center w-full justify-center"
        )}>
            <AppMenu menu={menu} mobile={false}/>
        </div>
            ):
            (<></>)
        )}
    </header>
    );
}




export default Header